import type { ApplicationLinkCreationResponse } from './CommonApplicationLinkCreationEntity.tsx';
import { putApplinkProvider } from './putApplinkProvider.tsx';

export const putApplinkOAuthOne2LOProvider = (
	id: string,
): Promise<ApplicationLinkCreationResponse> =>
	putApplinkProvider(
		id,
		'com.atlassian.applinks.api.auth.types.TwoLeggedOAuthAuthenticationProvider',
	);
